/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/modules/accessibility.js":
/*!*****************************************!*\
  !*** ./src/js/modules/accessibility.js ***!
  \*****************************************/
/***/ (() => {

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * Accessibility Enhancement for Product Swatches
 * Implements roving tabindex pattern for radio groups (role="radio").
 * Tab moves focus into the group; arrow keys navigate between swatches.
 * Handles dynamically loaded swatches using MutationObserver.
 */

document.addEventListener('DOMContentLoaded', function () {
  var SWATCH_SELECTOR = 'li.swatch-view-item';
  var DATA_ATTRIBUTE = 'data-accessibility-attached';
  function getGroup(item) {
    return item.closest('ul, [role="radiogroup"]');
  }
  function getSiblings(item) {
    var group = getGroup(item);
    if (!group) return [];
    return Array.from(group.querySelectorAll(SWATCH_SELECTOR));
  }
  function setRovingFocus(item) {
    var siblings = getSiblings(item);
    siblings.forEach(function (s) {
      return s.setAttribute('tabindex', '-1');
    });
    item.setAttribute('tabindex', '0');
    item.focus();
  }
  function attachSwatchListeners() {
    var newSwatchItems = document.querySelectorAll("".concat(SWATCH_SELECTOR, ":not([").concat(DATA_ATTRIBUTE, "])"));
    if (newSwatchItems.length === 0) return;
    newSwatchItems.forEach(function (item) {
      item.setAttribute(DATA_ATTRIBUTE, 'true');
      // Default all new items to -1; initGroup will promote the right one.
      item.setAttribute('tabindex', '-1');
      item.addEventListener('keydown', handleSwatchKeydown);
    });

    // For each group that has new items, ensure exactly one has tabindex="0".
    var affectedGroups = new Set();
    newSwatchItems.forEach(function (item) {
      var group = getGroup(item);
      if (group) affectedGroups.add(group);
    });
    affectedGroups.forEach(function (group) {
      var items = Array.from(group.querySelectorAll(SWATCH_SELECTOR));
      var checked = items.find(function (i) {
        return i.getAttribute('aria-checked') === 'true';
      });
      var target = checked || items[0];
      if (target && target.getAttribute('tabindex') !== '0') {
        target.setAttribute('tabindex', '0');
      }

      // Nav arrows have role="presentation" — remove them from tab order
      // so Tab exits the swatch component cleanly
      var wrapper = group.closest('.swatch-navigable');
      if (wrapper) {
        wrapper.querySelectorAll('.swatch-navigation[tabindex="0"]').forEach(function (nav) {
          nav.setAttribute('tabindex', '-1');
        });
      }
    });
  }
  function handleSwatchKeydown(e) {
    var siblings = getSiblings(this);
    var currentIndex = siblings.indexOf(this);
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      e.preventDefault();
      var next = siblings[(currentIndex + 1) % siblings.length];
      setRovingFocus(next);
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      e.preventDefault();
      var prev = siblings[(currentIndex - 1 + siblings.length) % siblings.length];
      setRovingFocus(prev);
    } else if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      // Click the inner .swatch-selector — the li itself has no click handler
      var inner = this.querySelector('.swatch-selector') || this;
      inner.dispatchEvent(new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
        detail: 1
      }));
    } else if (e.key === 'Escape' || e.key === 'Tab') {
      var _getGroup;
      e.preventDefault();
      var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
      var container = ((_getGroup = getGroup(this)) === null || _getGroup === void 0 ? void 0 : _getGroup.closest('.swatch-navigable')) || getGroup(this);
      if (!container) return;
      var all = Array.from(document.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return !container.contains(el);
      });
      if (e.shiftKey) {
        var _prev2;
        var _prev = all.filter(function (el) {
          return container.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_PRECEDING;
        });
        (_prev2 = _prev[_prev.length - 1]) === null || _prev2 === void 0 ? void 0 : _prev2.focus();
      } else {
        var _next = all.find(function (el) {
          return container.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING;
        });
        _next === null || _next === void 0 ? void 0 : _next.focus();
      }
    }
  }
  function disableImageWrapperLinks() {
    document.querySelectorAll('.product-item__image-wrapper a:not([tabindex="-1"])').forEach(function (link) {
      link.setAttribute('tabindex', '-1');
    });
  }
  attachSwatchListeners();
  disableImageWrapperLinks();
  var observer = new MutationObserver(function (mutations) {
    var shouldCheck = false;
    var _iterator = _createForOfIteratorHelper(mutations),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var mutation = _step.value;
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          var _iterator2 = _createForOfIteratorHelper(mutation.addedNodes),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _node$matches, _node$querySelector;
              var node = _step2.value;
              if (node.nodeType === Node.ELEMENT_NODE && ((_node$matches = node.matches) !== null && _node$matches !== void 0 && _node$matches.call(node, SWATCH_SELECTOR) || (_node$querySelector = node.querySelector) !== null && _node$querySelector !== void 0 && _node$querySelector.call(node, SWATCH_SELECTOR))) {
                shouldCheck = true;
                break;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          if (shouldCheck) break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (shouldCheck) {
      attachSwatchListeners();
      disableImageWrapperLinks();
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_accessibility__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/accessibility */ "./src/js/modules/accessibility.js");
/* harmony import */ var _modules_accessibility__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_modules_accessibility__WEBPACK_IMPORTED_MODULE_0__);
/*
DO NOT TOUCH THIS FILE OUTSIDE OF /src DIRECTORY
this file gets compiled ./assets/custom.js - make sure to import every module here.
*/


})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin

})();

/******/ })()
;